'use strict';

const _ = require('lodash');

/**
 * Revision is used for compare the old and new version of the content
 *
 * A content can be modified with new elements an new parameters, a data bag
 * is used for save the new/modfied data
 *
 * @author Florian Kroockmann <florian.kroockmann@lp-digital.fr>
 */
class Revision {
  /**
   * Constructor initialize the object with a config which contain:
   *
   * Mandatory:
   *   - uid (Identifier of content)
   *   - type (Nature of content)
   *
   * @param {object} config
   */
  constructor(config) {
    if (!_.isObject(config)) {
        throw new Error('Config must be set');
    }

    this.elements = null;
    this.parameters = null;
    this.uid = config.uid;
    this.type = config.type;

    if (!_.isString(this.uid)) {
      throw new Error('Uid must be set');
    }

    if (!_.isString(this.type)) {
      throw new Error('Type must be set');
    }
  }

  /**
   * Return the element by the key
   *
   * @param {string} key
   * @returns {Mixed} element
   */
  getElement(key) {
    return this.elements !== null ? this.elements[key] : undefined;
  }

  /**
   * Return the parameter by the key
   *
   * @param {string} key
   * @returns {Mixed} element
   */
  getParameter(key) {
    return this.parameters !== null ? this.parameters[key] : undefined;
  }

  /**
   * Set elements to the bag
   *
   * @param {object} elements
   * @returns {Revision} this
   */
  setElements(elements) {
      this.elements = elements;

      return this;
  }

  /**
   * Set parameters to the bag
   *
   * @param {object} parameters
   * @returns {Revision} this
   */
  setParameters(parameters) {
    this.parameters = parameters;

    return this;
  }

  /**
   * check if an element or parameter exist
   *
   * @returns {boolean} empty
   */
  isEmpty() {
    return null === this.elements && null === this.parameters;
  }

  /**
   * Remove elements from the bag
   *
   * @returns {Revision} this
   */
  removeElements() {
    this.elements = null;

    return this;
  }

  /**
   * Remove parameters from the bag
   *
   * @returns {Revision} this
   */
  removeParameters() {
    this.parameters = null;

    return this;
  }

  /**
   * Add element to the bag
   *
   * @param {string} key
   * @param {Mixed} value
   * @returns {Revision} this
   */
  addElement(key, value) {
    if (null === this.elements) {
      this.elements = {};
    }

    this.elements[key] = value;

    return this;
  }

  /**
   * Add parameter to the bag
   *
   * @param {string} key
   * @param {Mixed} value
   * @returns {Revision} this
   */
  addParameter(key, value) {
    if (null === this.parameters) {
      this.parameters = {};
    }

    this.parameters[key] = value;

    return this;
  }
}

module.exports = Revision;
